// export function getToken() {
//   return request({
//     url: '/qiniu/upload/token', // 假地址 自行替换
//     method: 'get'
//   })
// }

import request from '@/utils/request'
import host from '@/api/base/host'

const module = {
  mock: '',
  dev: 'v1/oss'
}
const path = host.path('dev', module)

export function getToken(tokenType) {
  return request({
    url: path(`token/sns/${tokenType}`),
    method: 'get'
  })
}

export default {
  getToken
}
